import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** FETCH INSTITUTION ******************
			case types.FETCH_INSTITUTION_LOADING:
				return { ...INITIAL_STATE };

			case types.FETCH_INSTITUTION_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_INSTITUTION_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			default:
				return state;
		}
	});
